import React from 'react';
// import styled from 'styled-components';

import {OzBand, OzContainer} from "@ozwol/webui";

import Layout from "./../components/Layout";


export default function NotFound() {
  const lang = "en";
  return (
    <Layout lang={lang}>
      <OzBand variant="whitesmoke">
        <OzContainer>
          <center>
            <h1>404</h1>
            Page Not Found
          </center>
        </OzContainer>
      </OzBand>
    </Layout>
  )

}
